import React from "react";
import {SiteData} from "../../Constants/siteData";
import {PageWrapper} from "../../Components/PageWrapper/PageWrapper";
import PageHeader from "../../Components/common/PageHeader";
import ServicePageTemplate from "../../Containers/ServiceContainers/ServicePageTemplate";
import {SEO} from "../../Components/SEO/SEO";

export default function TreePruning() {
    return (
        <PageWrapper>
            <SEO title={SiteData.treePruning.metaData.title} description={SiteData.treePruning.metaData.description}/>
            <PageHeader header={SiteData.treePruning.h1} subtitle={SiteData.treePruning.subtitle}/>
            <ServicePageTemplate body={SiteData.treePruning.body}/>
        </PageWrapper>
    )
}
